import React, {Component} from 'react';

//============================================================================
// expected props: 
//   title
//   src : image source url
//   onSelect : callabck
//   programTitle : 
//   duration : int ms

export default class Thumbnail extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	    };
	}
	
	pad(num, size) {
	    var s = "000000000" + num;
	    return s.substr(s.length-size);
	}
	
	// Shorten a string to less than maxLen characters without truncating words.
	shorten(str, maxLen, separator = ' ') {
	  if (str.length <= maxLen) return str;
	  return str.substr(0, str.lastIndexOf(separator, maxLen - 6)) + " [...]";
	}
	
	displayDuration(duration) {
		var secs = parseInt(duration, 10) / 1000
		return Math.floor(secs / 60) + ":" + this.pad(Math.floor((secs % 60)),2)
	}
	
	dateDisplayFromTimestamp(timestamp){
		if(timestamp)
		return new Date(timestamp).toLocaleDateString(
		    "en-US",
		    {
				//weekday: 'long',
				year: 'numeric',
				month: 'short',
				//day: 'numeric' 
			});
			return ''; 
	}
	
	render() {
		var normalStyle={
        }
		var fadedStyle={
		  "opacity": 0.8,
           "filter": "alpha(opacity=50)"
        };
        var selected = (!this.props.selected) ? "Add" : "Remove";
				//let scoreTitle = (this.props.rec_score) ? 'Score' : this.props.title;
				let scoreTitle = this.props.title;
				let scoreAvailable = (this.props.rec_score && this.props.rec_score !== null) ? (this.props.rec_score).toFixed(1) + "%" : (<span>{this.props.score}<span className="star">&#9733;</span></span>);
				let scoreLine = (<span className="score">{scoreAvailable}</span>);

        return (
            
		  <div className="card">
		  	<div className="card-img">
	  	    		<img className="card-image"
	  	    		  	alt={this.props.title}
						src={this.props.src}
						onClick={this.props.onSelect}
						style={(this.props.playableAbroad)?normalStyle:fadedStyle}
					/>
	  	    	  <div className="smallblackarea" onClick={this.props.onSelect}>{selected}</div>
	        </div>
	        
	  	   <div className="card-caption">
              <h4 onClick={this.props.onSelect}>{this.shorten(scoreTitle, 60)}</h4>
	       </div>
	       <div className="bottom">
           		{scoreLine}
	         	<span className="left">{this.dateDisplayFromTimestamp(this.props.publication_timestamp)}</span>
           </div>
	     </div>
	    );
	}
	
}